<payee-popup
  title="Ügy helyreállítása"
  description="Az ügyet kitörölték. Biztosan helyre akarod állítani?"
>
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [mat-dialog-close]="true"
    >
      Helyreállítás
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      mat-dialog-close
    >
      Bezárás
    </button>
  </ng-template>
</payee-popup>
